import React from "react";
import PropTypes from "prop-types";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";

import { FIELDS } from "apps/signup/util/constants";
import { CONFIRM_RECAPTCHA_SUCCESS } from "ducks/signup";
import Password from "./Password";
import Captcha from "./Captcha";

import "./index.scss";

if (process.env.PLATFORM === "desktop") {
	require("./index.desktop.scss");
} else {
	require("./index.mobile.scss");
}

const Registration = (props) => {
	return (
		<div className="signup2017-registration signup2017-field-wrapper">
			<Password
				key="password"
				value={props.password}
				onChange={props.onChange}
				validate={props.validate}
				success={props.success.password}
				dismissSuggestion={props.dismissSuggestion}
				hasError={props.errors.password}
				feedback={props.feedback.password}
				fieldName={FIELDS.PASSWORD}
				setCaptchaV3Token={props.setCaptchaV3Token}
			/>

			<CSSTransitionGroup
				transitionName="signup2017-captchaTransition"
				transitionEnterTimeout={600}
				transitionLeaveTimeout={600}
			>
				{props.showCaptcha &&
					<Captcha
						key="captcha"
						onVerify={props.storeCaptcha}
						captchaValue={props.captchaValue}
					/>
				}
				<GoogleReCaptcha
					onVerify={(token) => {
						props.confirmRecaptchaToken({
							type: CONFIRM_RECAPTCHA_SUCCESS,
							token,
							isCaptchaShowing: props.showCaptcha,
							page: "signup",
						});
					}}
					action="signup"
				/>
			</CSSTransitionGroup>
		</div>
	);
};

Registration.propTypes = {
	password: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	validate: PropTypes.func.isRequired,
	dismissSuggestion: PropTypes.func.isRequired,
	errors: PropTypes.object,
	feedback: PropTypes.object,
	success: PropTypes.object,
	showCaptcha: PropTypes.bool,
	storeCaptcha: PropTypes.func.isRequired,
	captchaValue: PropTypes.string.isRequired,
	confirmRecaptchaToken: PropTypes.func.isRequired,
	setCaptchaV3Token: PropTypes.func.isRequired,
};

Registration.defaultProps = {
	errors: {},
	feedback: {},
	success: {},
	showCaptcha: false,
};

export default Registration;



// WEBPACK FOOTER //
// ./src/apps/signup/components/Registration/index.jsx